import Swiper from "swiper/bundle";
import "swiper/css/bundle";

// Add to window
window.Swiper = Swiper;
